import { isStringNotEmpty } from '../../shared/objectUtils';
import EntityUtils from '../entityUtils';

export const getLaneDTO = (lane, trailerTypes = []) => {
    if (isStringNotEmpty(lane.trailerTypeId)) {
        lane.trailerType = EntityUtils.getTrailerTypeInfo(lane.trailerTypeId, trailerTypes);
    }

    return lane;
};